import { Group, Stack, Text } from '@mantine/core'

import type { Plan } from '@/services/api/api.types'
import { formatCostPerCredit, getFreePlanCredits, isPlanEligibleForBonus } from '@/utils/planUtils'

interface OrderSummaryProps {
  selectedPlan: Plan
  autoRefill: boolean
  allPlans?: Plan[]
}

export function OrderSummary({ selectedPlan, autoRefill, allPlans }: OrderSummaryProps) {
  return (
    <Stack gap="md" p="lg" style={{ backgroundColor: 'var(--mantine-color-gray-0)', borderRadius: '8px' }}>
      <Text fw={600} size="lg">
        Order Summary
      </Text>
      <Group justify="space-between">
        <Text>Credits included:</Text>
        <Text fw={500}>{selectedPlan.creditsPerBundle.toLocaleString()}</Text>
      </Group>
      <Group justify="space-between">
        <Text>Cost per credit:</Text>
        <Text fw={500} c="dimmed">
          {formatCostPerCredit(selectedPlan)}
        </Text>
      </Group>
      {isPlanEligibleForBonus(selectedPlan) && allPlans && (
        <Group justify="space-between">
          <Text>One-time bonus:</Text>
          <Text fw={500} c="green">
            +{getFreePlanCredits(allPlans).toLocaleString()} credits
          </Text>
        </Group>
      )}
      <Group justify="space-between">
        <Text>Auto-refill:</Text>
        <Text fw={500} c={autoRefill ? 'green' : 'dimmed'}>
          {autoRefill ? 'Enabled' : 'Disabled'}
        </Text>
      </Group>
      <hr style={{ margin: '8px 0', border: 'none', borderTop: '1px solid var(--mantine-color-gray-3)' }} />
      <Group justify="space-between">
        <Text fw={600} size="lg">
          Due now:
        </Text>
        <Text fw={600} size="lg">
          ${selectedPlan.priceDollars.toFixed(2)}
        </Text>
      </Group>
    </Stack>
  )
}
